import type { ReactNode } from "react";

interface Props {
  title: string;
  description: string;
  icon?: ReactNode;
}

export function PlaceholderPage({ title, description, icon }: Props) {
  return (
    <div className="mx-auto w-full max-w-3xl space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed bg-muted/20 p-12 text-center">
        {icon && (
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-background text-foreground/60">
            {icon}
          </span>
        )}
        <h2 className="text-lg font-medium">Coming next</h2>
        <p className="max-w-md text-sm text-muted-foreground">
          This view ships in the next phase. The contract is defined in the
          design docs under <code>docs/</code>.
        </p>
      </div>
    </div>
  );
}
